import en from "./en";
import fi from "./fi";
export default { en: en, fi: fi };



//////////////////
// WEBPACK FOOTER
// ./app/ts/i18n/index.ts
// module id = 229
// module chunks = 0